import React from 'react';
import { AssetTypeEnum } from './enums';
import { Asset } from './asset_search';
import { PaletteMode } from '@mui/material';

// Request headers
export enum Headers {
  Authorization = 'authorization',
  Accept = 'Accept',
}

export interface SearchInputDto {
  siteId: string;
  params: string;
}

export type ClientConfig = {
  name: string;
  siteId?: string;
  assetType: AssetTypeEnum;
  logoLocation: string;
  largeLogoLocation: string;
  faviconLocation: string;
  mapboxSW: Point;
  mapboxNE: Point;
  mapboxToken: string;
  mapboxStyle: string;
  featureFlags?: FeatureFlags;
  orgCode: string;
};

export type ClientConfigRequest = {
  siteId?: string;
};

export interface RouteType {
  path: string;
  element: React.FunctionComponent;
  title: string;
  exact?: boolean;
  index?: boolean;
}

export type UserState = {
  status: any;
  siteId: any;
  siteMetadata: ClientConfig;
  theme: PaletteMode;
  language: string;
  userPosition: Point | null;
  tetheredEnabled: boolean;
  sortedAssetPosition: boolean;
  satelliteView: boolean;
};

export type Point = {
  lat: number;
  lon: number;
};

export type FiltersState = {
  assetTable: {
    search: string;
    assetFiltered: Asset[];
    refetch: boolean;
  };
};

export type FeatureFlags = {
  dtcEnabled?: boolean;
  sellerIdEnabled?: boolean;
  stockNumberEnabled?: boolean;
  vehicleBatteryEnabled?: boolean;
  workOrderEnabled?: boolean;
  geofenceEnabled?: boolean;
  dtcDisclaimerEnabled?: boolean;
  markAsFound?: boolean;
};
